var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link-map"},[_c('div',{staticClass:"title"},[_vm._v("网站地图")]),_c('div',{staticClass:"subs"},_vm._l((_vm.map),function(item){return _c('div',{key:item.path,class:{ sub: true, active: _vm.$route.path == item.path }},[_c('router-link',{attrs:{"to":item.path}},[_vm._v(_vm._s(item.name))])],1)}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }